import React from 'react'
import styles from './styles.css'
import gql from 'graphql-tag'
import PropTypes from 'prop-types'
import {TiPen} from 'react-icons/lib/ti'

export default class Signature extends React.Component {
  static propTypes = {
    user: PropTypes.object
  }

  static fragment = gql`
    fragment userSignature on User {
      signature {
        _id
        image {
          url
        }
      }
    }
  `

  renderSignature() {
    if (this.props.user.signature) {
      return (
        <div>
          <div
            className={styles.signature}
            style={{backgroundImage: `url(${this.props.user.signature.image.url})`}}
          />
        </div>
      )
    } else {
      return (
        <div className={styles.menuLink}>
          <TiPen size={22} />
          <span>Firmas</span>
        </div>
      )
    }
  }

  render() {
    return (
      <div onClick={global.openSignature} className={styles.container}>
        {this.renderSignature()}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Layout/Navbar/User/Signature/index.js